import type { RouteObject } from "react-router-dom";
import { addSlashes, withCompanyPrefix } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import { CompanySetupGuide } from "@/utils/lazyLoadComponents";

/**
 * Company setup ("go-live") guide — takes a new workspace from subscription
 * through to its first payroll run.
 *
 * Named `setup`, NOT `onboarding`: that segment already belongs to the EMPLOYEE
 * onboarding module (`routes.onboarding.ts`), as do the `onboarding` sidebar key
 * and `PLATFORM_SECTION_ENUM.ONBOARDING`.
 */

// ─── Path Segments ────────────────────────────────────────────────────────────
export enum COMPANY_SETUP_PATH_SEGMENTS {
  ROOT = "setup",
}

// ─── Route Definition ─────────────────────────────────────────────────────────
export const companySetupRoutes: RouteObject = {
  path: COMPANY_SETUP_PATH_SEGMENTS.ROOT,
  // `breadcrumb` only, like every other module root: HeaderBreadcrumbs'
  // `resolveTitle()` already falls back to the deepest breadcrumb, so a `title`
  // identical to it just duplicates the string. Sub-routes set `title` when it
  // needs to differ from the crumb.
  handle: { breadcrumb: "Setup Guide" },
  HydrateFallback: Spinner,
  children: [{ index: true, Component: CompanySetupGuide }],
};

// ─── Resolved Paths ───────────────────────────────────────────────────────────
const _SETUP_ROOT = withCompanyPrefix(
  addSlashes(COMPANY_SETUP_PATH_SEGMENTS.ROOT),
);

export const COMPANY_SETUP_PATHS = Object.freeze({
  ROOT: _SETUP_ROOT,
});
